import { getSafeSupabaseClient } from '../supabaseSync';
import { unwrapRpcResult } from './rpcEnvelope';

export interface OpenInquiryArgs {
  loopId: string;
  question: string;
  actorId: string;
  actorName?: string | null;
}

export interface OpenInquiryResult {
  success: boolean;
  inquiry_id: string;
  loop_id: string;
  status: 'OPEN';
}

/**
 * Open an inquiry (child→parent clarification request).
 * 
 * Does NOT change loop state (inquiry is informational).
 * 
 * Atomic transaction:
 * - Inserts handoff_inquiries record with status OPEN
 * - Emits governance event (inquiry_opened)
 */
export async function openInquiry(args: OpenInquiryArgs): Promise<OpenInquiryResult> {
  const supabase = getSafeSupabaseClient();
  if (!supabase) {
    throw new Error('Supabase client not available');
  }

  if (!args.question || args.question.trim() === '') {
    throw new Error('Inquiry question is required');
  }

  const { data, error } = await supabase.rpc('catchball_open_inquiry', {
    p_loop_id: args.loopId,
    p_question: args.question,
    p_actor_id: args.actorId,
    p_actor_name: args.actorName ?? null,
  });

  // Refusals arrive either as a PostgREST error or as { success: false, error }.
  return unwrapRpcResult<OpenInquiryResult>(data, error, 'The server refused the question.');
}
